import React, { useState } from 'react';
import getActivities from 'api/comments/getActivities';

export interface GPDActivity {
	Id: string;
	Title: string;
}

const useActivities = () => {
	const [activities, setActivities] = useState<GPDActivity[]>([]);
	const [loadingActivities, setLoadingActivities] = useState<boolean>(false);

	const fetchActivities = async (deliverableID: number | null) => {
		if (!deliverableID) return;
		try {
			setLoadingActivities(true);
			const activities = await getActivities(deliverableID);
			setActivities(activities);
		} catch (e) {
			console.error(e);
		} finally {
			setLoadingActivities(false);
		}
	};
	return {
		activities,
		loadingActivities,
		setActivities,
		fetchActivities,
	};
};

export default useActivities;
